import { useEffect, useState } from 'react';

import { EmailInputProps } from './email-input.component';

interface ViewProps {
    valid: boolean;
    touched: boolean;
    inputClass: string;
    isValid: () => boolean;
    changeTouched: React.Dispatch<React.SetStateAction<boolean>>;
}

export const emailRegex = /(.+)@(.+){1,}\.(.+){2,}/;

const useEmailInput = (props: EmailInputProps): ViewProps => {
    const [touched, changeTouched] = useState<boolean>(false);
    const [valid, changeValid] = useState<boolean>(props.valid !== undefined ? props.valid : true);

    const isValid = (): boolean => {
        let isValid = true;

        if (props.valid !== undefined) {
            isValid = props.valid;
        } else {
            if (props.required === true && (props.value === '' || props.value === undefined)) isValid = false;
            if (!emailRegex.test(props.value!)) isValid = false;
        }

        changeValid(isValid);
        return isValid;
    };

    useEffect(() => {
        if (props.isValidCallback) {
            props.isValidCallback(isValid());
        } else isValid();
    }, [props.value, props.valid, props.required]);

    useEffect(() => {
        if (props.submitted) {
            !touched && changeTouched(true);
        }
    }, [props.submitted]);

    return {
        valid,
        touched,
        inputClass: '',
        isValid,
        changeTouched
    };
};

export default useEmailInput;
